module.exports = __webpack_public_path__ + "media/Podcast-Pensamiento-creativo-resolucion-conflictos-laborales.585ea8b6.mp3";